module.exports = __webpack_public_path__ + "static/media/2003_maleRate_femaleRate.4e9a3bb6.png";